import { render, staticRenderFns } from "./WeightTable.vue?vue&type=template&id=145710de&"
import script from "./WeightTable.vue?vue&type=script&lang=js&"
export * from "./WeightTable.vue?vue&type=script&lang=js&"
import style0 from "./WeightTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports